/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_ImportingInputs */

const en_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing project file:`)
};

const fr_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du fichier projet :`)
};

const de_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektdatei wird importiert:`)
};

const it_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del file di progetto:`)
};

const ru_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт файла проекта:`)
};

const es_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando archivo de proyecto:`)
};

const zh_cn2_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入项目文件：`)
};

const ja_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト ファイルをインポートしています:`)
};

const hi_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल आयात करना:`)
};

const pt_pt2_load_project_file_status_importing = /** @type {(inputs: Load_Project_File_Status_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando arquivo de projeto:`)
};

/**
* | output |
* | --- |
* | "Importing project file:" |
*
* @param {Load_Project_File_Status_ImportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_importing = /** @type {((inputs?: Load_Project_File_Status_ImportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_ImportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_importing(inputs)
	if (locale === "de") return de_load_project_file_status_importing(inputs)
	if (locale === "it") return it_load_project_file_status_importing(inputs)
	if (locale === "ru") return ru_load_project_file_status_importing(inputs)
	if (locale === "es") return es_load_project_file_status_importing(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_importing(inputs)
	if (locale === "ja") return ja_load_project_file_status_importing(inputs)
	if (locale === "hi") return hi_load_project_file_status_importing(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_importing(inputs)
	return en_load_project_file_status_importing(inputs)
});